import { styled } from '@mui/material/styles';
import { Chip } from '@mui/material';

export const BedConfigChipRoot = styled(Chip, {
  shouldForwardProp: prop => prop !== 'compact',
})(({ theme, compact }) => ({
  height: 20,
  fontSize: 11,
  fontWeight: 500,
  color: theme.palette.greyBlue.main,
  borderColor: theme.palette.greyBlue.white40,
  '& .MuiChip-label': {
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(0.75),
  },
  ...(compact && {
    height: 18,
    fontSize: 10,
    cursor: 'default',
  }),
}));
